<template>
   <div class="passenger-information-summary-wrapper hotel-order-detail-inner-section">
      <div class="passenger-information-summary-inner">
         <div class="passenger-information-table-wrapper">
            <table class="passenger-information-table">
               <thead>
                  <tr>
                     <th>{{ $t("orderDetail_lblPassengerInfoRoomType") }}</th>
                     <th>{{ $t("orderDetail_lblGuestType") }}</th>
                     <th>{{ $t("orderDetail_lblGender") }}</th>
                     <th>{{ $t("orderDetail_lblName") }}</th>
                     <th>{{ $t("orderDetail_lblBirthdate") }}</th>
                     <th>{{ $t("orderDetail_lblNationality") }}</th>
                  </tr>
               </thead>
               <tbody v-for="(roomItem, roomIndex) in passengers" :key="roomIndex" class="room-group">
                  <tr v-for="(guestItem, guestIndex) in roomItem.guests" :key="guestIndex">
                     <td :data-label="$t('orderDetail_lblPassengerInfoRoomType')" class="room-name-cell">
                        <span v-if="guestIndex === 0">{{ roomItem.channelRoomName }}</span>
                     </td>
                     <td :data-label="$t('orderDetail_lblGuestType')">{{ guestItem.type | EHtlGuestType }}</td>
                     <td :data-label="$t('orderDetail_lblGender')">{{ guestItem.gender | EComGender }}</td>
                     <td :data-label="$t('orderDetail_lblName')">{{ guestItem.name }} {{ guestItem.surname }}</td>
                     <td :data-label="$t('orderDetail_lblBirthdate')">
                        <span v-if="guestItem.type == 2">{{ guestItem.birthdate | fullDateFormat }}</span>
                        <span v-else>-</span>
                     </td>
                     <td :data-label="$t('orderDetail_lblNationality')">{{ guestItem.nationality }}</td>
                  </tr>
               </tbody>
            </table>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: "PassengerInformationSummary",
   props: {
      passengerList: { type: Array },
   },
   data() {
      return {
         passengers: [],
      };
   },
   created() {
      const self = this;
      self.passengers = this.passengerList;
   },
   watch: {
      passengerList: {
         handler: function (newPassengerList) {
            const self = this;
            self.passengers = newPassengerList;
         },
         deep: true,
      },
   },
};
</script>

<style lang="scss" scoped>
.passenger-information-summary-wrapper {
   .passenger-information-summary-inner {
      .passenger-information-table-wrapper {
         overflow-x: auto;

         .passenger-information-table {
            width: 100%;
            border-collapse: separate;
            border-spacing: 0;
            border: 1px solid var(--gray-300);
            border-radius: 10px;
            overflow: hidden;

            thead {
               tr {
                  background-color: var(--gray-200);

                  th {
                     padding: 16px;
                     text-align: left;
                     font-size: 14px;
                     font-weight: 600;
                     color: var(--gray-700);
                     border-bottom: 1px solid var(--gray-300);
                     border-right: 1px solid var(--gray-300);

                     &:last-child {
                        border-right: none;
                     }
                  }
               }
            }

            tbody.room-group {
               &:not(:last-child) {
                  tr:last-child {
                     td {
                        border-bottom: 2px solid var(--gray-200);
                     }
                  }
               }

               tr {
                  background-color: var(--container-bg);
                  border-bottom: 1px solid var(--gray-300);

                  &:last-child {
                     border-bottom: none;
                  }

                  td {
                     padding: 16px;
                     font-size: 14px;
                     font-weight: 500;
                     border-right: 1px solid var(--gray-300);

                     &:last-child {
                        border-right: none;
                     }

                     &.room-name-cell {
                        font-weight: 700;
                        vertical-align: top;
                     }
                  }
               }
            }
         }

         @media (max-width: 767.98px) {
            .passenger-information-table {
               border: none;

               thead {
                  display: none;
               }

               tbody.room-group {
                  display: block;
                  margin-bottom: 24px;

                  &:last-child {
                     margin-bottom: 0;
                  }

                  &:not(:last-child) {
                     tr:last-child {
                        td {
                           border-bottom: 1px solid var(--gray-300);
                        }
                     }
                  }

                  tr {
                     display: block;
                     margin-bottom: 16px;
                     border: 1px solid var(--gray-300);
                     border-radius: 10px;
                     overflow: hidden;

                     &:last-child {
                        margin-bottom: 0;
                     }

                     td {
                        display: grid;
                        grid-template-columns: 40% 60%;
                        padding: 12px 16px;
                        border-right: none;
                        border-bottom: 1px solid var(--gray-300);
                        text-align: left;

                        &:last-child {
                           border-bottom: none;
                        }

                        &::before {
                           content: attr(data-label);
                           font-weight: 700;
                           font-size: 14px;
                           color: var(--gray-700);
                           padding: 0;
                           display: flex;
                           align-items: center;
                        }

                        &.room-name-cell {
                           grid-template-columns: 1fr;
                           background-color: var(--gray-100);
                           font-weight: 700;
                           padding: 16px;

                           span {
                              font-size: 16px;
                           }

                           &::before {
                              content: attr(data-label);
                              display: block;
                              font-size: 14px;
                              color: var(--gray-700);
                              margin-bottom: 8px;
                              font-weight: 600;
                           }

                           &:empty {
                              display: none;
                           }
                        }
                     }
                  }
               }
            }
         }
      }
   }
}
</style>
